import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ButtonToolbar } from 'react-bootstrap'
import { getAllScenarioCloseLoop } from '../../components/UserFunctions'
import '../menuIcon.css'
// import InputRange from 'react-input-range';
import "react-input-range/lib/css/index.css";
// import { getFilterOptions } from '../UserFunctions'
// import { Link } from 'react-router-dom'
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import VirtualizedSelect from 'react-virtualized-select'
import {PrivilegeError} from './../../authComponents/errorComponents';


class AdvanceSearchModalCloseLoop extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef()
        this.state = {

            scenario_uuid_selected: [],
            scenario_name_selected: [],
            description_selected: [],
            
        };
    };
    reset = () => {
        this.formRef.current.reset()
      }
    handleChange = date => {
        this.setState({
            startDate: date
        });
    };


    onScenarioUUIDChangeHandler = (event) => {
        this.setState({
            scenario_uuid_selected: event.target.value,            
        })
    }

    onScenarioNameChangeHandler = (event) => {
        this.setState({
            scenario_name_selected: event.target.value
        })
    }

    onDescriptionChangeHandler = (event) => {
        this.setState({
            description_selected: event.target.value
        })
    }

    onResultChange = (result) => {
        if (this.state.result_list_selected.includes(result)) {
            this.setState({
                result_list_selected: this.state.result_list_selected.filter((element => element !== result))
            })
        } else {
            this.setState({
                result_list_selected: [...this.state.result_list_selected, result]
            })
        }
    }

    onSearchFilter(e) {
        this.props.onSearchClick(this.state.scenario_uuid_selected, this.state.scenario_name_selected,this.state.description_selected)
    };

    onResetFilter = (e) => {
        document.getElementById('scenariouuid').value = null
        document.getElementById('scenarioname').value = null
        document.getElementById('description').value = null
        this.setState({
            scenario_uuid_selected : "",
            scenario_name_selected : "",
            description_selected : "",
        })
        
    };

    componentDidMount() {
        const dest_url = (window.location.origin).concat('/close_loop_fetch_all_scenario')
        getAllScenarioCloseLoop(dest_url).then(res => {
        	console.log("close loop scenario view : ",res.data.data)
            this.setState( prevState => {
                return{
                    data: res.data.data
                }
            })
        }).catch( error =>{
            this.setState((prevState)=>{
                return {
                    ...prevState,
                    error: true,
                    errorRes: error
                }
            })
        })
    }

    render() {
        return (
            <div>
                <Modal 
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    isOpen={true}>
                    <ModalHeader
                        toggle={this.props.closeSearchModal}
                        style={{ fontWeight: "bold", color: "#524fa1" }}
                    >
                        Advance Search
                    </ModalHeader>
                    <ModalBody>
                        <div class="container">
                            {
                                this.state.error ? <PrivilegeError error={this.state.errorRes} /> : null
                            }
                            <div className="row">
                                <div className="col-md-6" style={{ display: "inline-block" }}>
                                   
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12" style={{ border: "1px solid #858AFF", backgroundColor: "#757AF7" }}>
                                   
                                <form>
                                    <div style={{ width: "13rem", padding: "5px", display: "inline-block" }}>
                                        <div style={{ float: "left", padding: "5px", display: "inline-block", color: "#FFFFFF", fontWeight: "bold" }}>
                                            Scenario UUID :
                                            </div>
                                        <div style={{ float: "left", padding: "5px", width: "4rem", display: "inline-block" }}>
                                           
                                            <input type="text" id = "scenariouuid" placeholder=" Scenario UUID " style={{ width: "8rem" }} onChange={(e) => this.onScenarioUUIDChangeHandler(e)} />
                                        </div>
                                    </div>

                                    <div style={{ width: "50rem", padding: "5px", display: "inline-block" }}>
                                        <div style={{float: "left", padding: "5px", display: "inline-block", color: "#FFFFFF", fontWeight: "bold" }}>
                                            Scenario Name :
                                            </div>
                                        <div style={{ float: "left", padding: "5px", width: "4rem", display: "block" }}>
                                           
                                            <input type="text" id = "scenarioname" placeholder=" Scenario Name " style={{ width: "9rem" }} onChange={(e) => this.onScenarioNameChangeHandler(e)}/>
                                        </div>
                                    </div>

                                    <div style={{ width: "14rem", padding: "5px", display: "inline-block" }}>
                                        <div style={{ float: "left", padding: "5px", display: "inline-block", color: "#FFFFFF", fontWeight: "bold" }}>
                                            Description :
                                            </div>
                                        <div style={{ float: "left", padding: "5px", width: "4rem", display: "inline-block" }}>
                                                       
                                            <input type="text" id = "description" placeholder=" Description " style={{ width: "8rem" }} onChange={(e) => this.onDescriptionChangeHandler(e)}/>
                                        </div>
                                    </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        
                    </ModalBody>
                    <ModalFooter>
                        <ButtonToolbar>
                            <button type="button" className="btn" style={{ cursor: "pointer", color: "#212121", backgroundColor: "#B0FF44" }}
                                onClick={() => this.onSearchFilter()}>
                                Search
                            </button>
                            <button type="button" className="btn" style={{ cursor: "pointer", color: "#212121", backgroundColor: "#B0FF44" ,marginLeft:"1rem"}}
                                onClick={(e)=>this.onResetFilter(e)}>
                                Clear All
                            </button>
                        </ButtonToolbar>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default AdvanceSearchModalCloseLoop